// extracted by mini-css-extract-plugin
export default {"root":"AuthBar_root__nEU5f"};